import styled from "@emotion/styled";
import { Form } from "antd";
import UploadImages from "../../UploadImages";
import { FC } from "react";
import { allowFileExtensionsImage } from "config";

interface CampaignImageCardProps {
  is_active: boolean;
  setCheckIsActive: (checkIsActive: boolean) => void;
}

const CampaignImageCard: FC<CampaignImageCardProps> = ({ is_active, setCheckIsActive }) => {
  return (
    <>
      <UploadWrapper>
          <Form.Item
            label="รูปภาพหลัก"
            name="main_images"
            required
            rules={[
              {
                required: true,
                message: "กรุณาเพิ่มรูปภาพสินค้า",
              },
            ]}
          >
          <UploadImages maximumUploadItems={1} allowFileExtensions={allowFileExtensionsImage}/>
        </Form.Item>
      </UploadWrapper>
    </>
  );
};

export default CampaignImageCard;

// scroll x direction
const UploadWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  padding: 10px;
  background-color: #ffffff;
`;
